import { getBrightness } from './getBrightness';
import { setSystemBrightness } from './setBrightness';

export const decreaseBrightness = async () => {
  const value = await getBrightness();
  return await setSystemBrightness(Math.max(value - 0.2, 0));
};
